import { useState } from 'react';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';

import ManageTemplate from './ManageTemplate';

const ManageTemplatePage = () => {
  const [checkBoxState, setCheckBoxState] = useState([]);
  const [itemCheck, setItemCheck] = useState([]);
  const location = useLocation();
  const [withAmount, setWithAmount] = useState(false);

  return (
    <ManageTemplate
      checkBoxState={checkBoxState}
      itemCheck={itemCheck}
      previusPath={location.pathname}
      setCheckBoxState={setCheckBoxState}
      setItemCheck={setItemCheck}
      setWithAmount={setWithAmount}
      withAmount={withAmount}
    />
  );
};

export default ManageTemplatePage;
